import { Router } from '@angular/router';
import { Component, OnInit, inject } from '@angular/core';
import { AppConfigService, TokenService } from '@cudirect/shared-ui-library';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'cu-admin-logout',
  templateUrl: './admin-logout.component.html',
  styleUrls: [],
  standalone: true,
  imports: [CommonModule]
})
export class AdminLogoutComponent implements OnInit {
  // Use inject pattern instead of constructor injection
  private readonly tokenService = inject(TokenService);
  private readonly router = inject(Router);
  private readonly configService = inject(AppConfigService);

  ngOnInit(): void {
    this.tokenService.configureCache(
      this.configService?.settings?.adminPortalTokenStorageType || 'sessionStorage',
      this.configService?.settings?.adminPortalCachedTokenName || 'admin-portal-user-session'
    );
    this.tokenService.clearCachedToken();
    this.router.navigate(['admin/login'], { queryParamsHandling: 'preserve' });
  }
}
